import ko from '@tko/build.knockout';
import $ from 'jquery';
import _ from 'lodash';
import FormatterCommon from './formatter-common';
import GridFormatterCommon from './grid-formatter-common';
import FilterFormatter from './filter-formatter';
import moment from 'moment-timezone';
import QualityIndicators from '../helpers/quality-indicators';



    function EndpointStatusSearchGridFormatter(params, observableOptions) {
        var self = this;

        self.observableOptions = observableOptions;

        self.formatterCommon = FormatterCommon;
        self.gridFormatterCommon = new GridFormatterCommon();
        self.filterFormatter = new FilterFormatter();

        self.isCallControl = params && params.type === 'CallControl';
        self.isBridge = params && params.type === 'Bridge';

        self.observableFormattedData = ko.observable({});

        self.subscriptions = [];
    }

    function ComposeData(sourceList, endpointCallData, options, formatters, metadata) {
        var headers = metadata.searchgrid.headers;
        var innerheaders = metadata.searchgrid.innerheaders;
        var rowProperties = metadata.searchgrid.rowProperties;
        const widths = ['', '', '', '', '', '', '', '', '', '', '', '', '', ''];

        if ($.isEmptyObject(sourceList)) {
            return formatters.gridformattercommon.composeEmpty(headers, rowProperties, widths);
        }
        var list = [];
        var finalList = [];

        var statusfilter = _.get(options, 'filter.statuses', null);
        var endpointfilter = _.get(options, 'filter.endpoints', null);
        var searchfilter = formatters.filterFormatter.toTypeaheadFilter(_.get(options, 'filter'));

        sourceList.forEach(function (item) {
            var hasdetail = item.hasDetail;
            var aliases = item.aliases ? item.aliases.split("/") : null;
            var rtdata = { numCalls: [{ text: -1 }], MaxPacketLossPercent: [{ text: 0 }], MaxJitter: [{ text: 0 }] };
            var innerrows;

            if (hasdetail === "true") {
                 rtdata = item.RtData[0];
                 innerrows = ko.observableArray(GetCallQualityData(rtdata, endpointCallData, formatters.gridFormatterCommon, formatters.formatterCommon));
             } else {
                 innerrows = null;
             }

            if (aliases) {
                item.sip = aliases[0] || "";
                item.h323 = aliases[1] || "";
                item.e164 = aliases[2] || "";
            }

            // We create this new property because the Endpoint Tag filter defined data-repository looks for this property
            // TODO: Refactor so filters can refer to a list of properties instead of creating properties that aggregate others.
            if (item.tags && item.tmsTag) {
                item._allTags = item.tags + ',' + item.tmsTag;
            }
            else {
                item._allTags = item.tags || item.tmsTag || '';
            }

            item.numcalls = (rtdata.numCalls && parseInt(rtdata.numCalls[0].text) >= 0 ) ? parseInt(rtdata.numCalls[0].text) : null;

            var qualityIndicator = ((rtdata.numCalls ? parseInt(rtdata.numCalls[0].text) : -1) > -1) ? item.qualityIndicator : -1;
            item.qualityString = (qualityIndicator > 0) ? QualityIndicators.getQualityString(qualityIndicator) : " ";

            var statusmatch = _.isEmpty(statusfilter) || formatters.gridFormatterCommon.matchStatusFilter(item.status, statusfilter);
            var endpointmatch = _.isEmpty(endpointfilter) || _.includes(endpointfilter, item.name);
            var searchmatch = _.isEmpty(searchfilter) || formatters.filterFormatter.matchAll(item, searchfilter);

            if (statusmatch && endpointmatch && searchmatch) {
                list.push({
                    id: item.id,
                    name: item.name,
                    sip: item.sip,
                    h323: item.h323,
                    e164: item.e164,
                    dn: item.dn || '',
                    model: item.model || '',
                    firmware: item.firmware,
                    status: formatters.gridFormatterCommon.convertStatusToNumber(item.status),
                    hwstatus: item.AVS ? formatters.gridFormatterCommon.getHwStatusValue(item.AVS) : 0,
                    host: item.host,
                    numcalls: item.numcalls,
                    qualityIndicator: qualityIndicator,
                    callLink: '',
                    innerheaders: innerheaders,
                    innerrows: innerrows,
                    AVS: item.AVS,
                    solarwindsLink: item.solarwindsLink,
                    tags: item.tags,
                    tmsTag: item.tmsTag,
                    _allTags: item._allTags
                });
            }
        });

        var sortableProperties = metadata.searchgrid.sortableProperties;
        var sortedList = formatters.gridFormatterCommon.sortList(list, sortableProperties, options, metadata.searchgrid.numericKeys);
        var pagedList = formatters.gridFormatterCommon.pageList(sortedList, options);


        pagedList.forEach(function (item) {
            var hasdetailsflag = item.numcalls > -1;

            finalList.push({
                id: item.id,
                name: formatters.gridFormatterCommon.getSolarWindsAndDetailLink(formatters.formatterCommon.sanitize(item.name), null, item.id),
                sip: item.sip,
                h323: item.h323,
                e164: item.e164,
                dn: item.dn || '',
                model: formatters.formatterCommon.getSpanTitle(item.model),
                firmware: formatters.formatterCommon.getSpanTitle(item.firmware),
                status: formatters.gridFormatterCommon.getStatusMarkupForEndpoint(item.status),
                hwstatus: item.AVS ? formatters.gridFormatterCommon.getHwStatusMarkup(item.AVS) : '',
                host: formatters.gridFormatterCommon.getLinkWithHost(item.host),
                numcalls: hasdetailsflag ? item.numcalls : " ",
                qualityIndicator: hasdetailsflag ? formatters.gridFormatterCommon.getQualityMarkup(item.qualityIndicator) : ' ',
                callLink: '',
                tags: formatters.formatterCommon.sanitize(item.tags),
                tmsTag: formatters.formatterCommon.sanitize(item.tmsTag),
                _allTags: formatters.formatterCommon.sanitize(item._allTags),

                _innerheaders: item.innerheaders,
                _innerrows: item.innerrows,
                _showInnerPager : false
            });
        });

        return {
            maxCount: list.length,
            rows: finalList,
            headers: headers,
            rowProperties: rowProperties,
            widths: ['', '', '', '', '', '', '', '', '', '', '', '', '', ''],
            innerRowDisplayIndex: 0
        };
    }

    function arrayOrNull(item) {
        return _.isArray(item) ? item : null;
    }

    function GetCallQualityData(rtdata, endpointCallData, gridformattercommon, formatterCommon) {
        var result = [];

        if (rtdata && rtdata.calls && rtdata.calls.length > 0) {
            for (var i = 0; i < rtdata.calls.length; i++) {
                var call = rtdata.calls[i];

                if (call.id && (call.id.length > 0) && (call.id[0].text)) {
                    var id = call.id[0].text;

                    if (!$.isEmptyObject(endpointCallData) && !$.isEmptyObject(endpointCallData[id])) {
                        var list = endpointCallData[id];
                        var obj = list[list.length - 1];

                        if (obj) {
                            var newobj = {
                                name: formatterCommon.getSpanTitle(obj.name),
                                remoteaddr: formatterCommon.getSpanTitle(obj.remoteaddr),
                                calltype: obj.calltype,
                                bitrate: obj.bitrate ? obj.bitrate + " kbps" : "",
                                presentation: formatterCommon.getSpanTitle(obj.presentation),
                                starttime: gridformattercommon.getTimeString(obj.starttime),
                                duration: gridformattercommon.GetDurationString(obj.duration),
                                packetloss: gridformattercommon.getQualityMetricMarkupWithoutUnits(obj.packetlossQualityIndicator, obj.maxPacketloss),
                                jitter: gridformattercommon.getQualityMetricMarkupWithoutUnits(obj.jitterQualityIndicator, obj.maxJitter),
                                details: "<a href='#quality/?nosave=true" + encodeURIComponent(id) + "' title='quality details'>Details</a>"
                            };
                            result.push(newobj);
                        }
                    }
                }
            }
        }
        return result;
    }

    EndpointStatusSearchGridFormatter.prototype.RefreshData = function () {
        var self = this;

        self.observableFormattedData(ComposeData(
            self.dataRepository.endpointStatusData(),
            self.dataRepository.endpointCallData(),
            self.observableOptions(),
            {
                filterFormatter: self.filterFormatter,
                gridFormatterCommon: self.gridFormatterCommon,
                formatterCommon: self.formatterCommon
            },
            self.dataRepository.getEndpointsMetadata()
        ));

    };

    EndpointStatusSearchGridFormatter.prototype.DataUpdated = function () {
        var self = this;
        self.RefreshData();
    };

    EndpointStatusSearchGridFormatter.prototype.OptionsUpdated = function () {
        var self = this;
        self.RefreshData();
    };

    EndpointStatusSearchGridFormatter.prototype.initialize = function (dataRepository) {
        var self = this;

        self.dataRepository = dataRepository;

        self.subscriptions.push(dataRepository.endpointStatusData.subscribe(function () { self.DataUpdated(); }));
        self.subscriptions.push(self.observableOptions.subscribe(function () { self.OptionsUpdated(); }));

        //initialize data if it is there, so that if it isn't a 'loading' icon will show on UI
        if (!$.isEmptyObject(dataRepository.endpointStatusData())) {
            self.RefreshData();
        }
    };

    EndpointStatusSearchGridFormatter.prototype.getObservableData = function () {
        var self = this;
        return self.observableFormattedData;
    };

    EndpointStatusSearchGridFormatter.prototype.dispose = function() {
        var self = this;
        self.subscriptions.forEach(function (sub) {
            sub.dispose();
        });
    };

    export default EndpointStatusSearchGridFormatter;
